'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useEffect, useRef } from 'react';
import { api } from '~/libs/api';
import { RewardsTierCard } from './RewardsTierCard';
import styles from './RewardsTierComparison.module.css';
import { REWARDS_TIERS } from './RewardsTiers.config';
export function RewardsTierComparison() {
  const $ = _c(16);
  const t = useTranslations("account");
  const trackRef = useRef(null);
  const currentItemRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      refetchOnWindowFocus: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: liveCustomer
  } = api.account.loyaltyStatus.useQuery(undefined, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      staleTime: 1800000
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: tiers
  } = api.account.loyaltyTiers.useQuery(undefined, t1);
  const activeTierId = liveCustomer?.tierId;
  let t2;
  if ($[2] !== tiers) {
    t2 = Object.fromEntries((tiers ?? []).map(_temp));
    $[2] = tiers;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const discounts = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = Math.max(...REWARDS_TIERS.map(_temp2));
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const maxBenefitRows = t3;
  const hasCentredRef = useRef(false);
  let t4;
  let t5;
  if ($[5] !== activeTierId) {
    t4 = () => {
      if (hasCentredRef.current || activeTierId === undefined) {
        return;
      }
      const track = trackRef.current;
      const current = currentItemRef.current;
      if (!track || !current) {
        return;
      }
      if (track.scrollWidth <= track.clientWidth) {
        return;
      }
      hasCentredRef.current = true;
      track.scrollTo({
        left: current.offsetLeft - (track.clientWidth - current.clientWidth) / 2
      });
    };
    t5 = [activeTierId];
    $[5] = activeTierId;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== t) {
    t6 = t("rewards_tiers_list_label");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== activeTierId || $[11] !== discounts) {
    t7 = REWARDS_TIERS.map(tier_1 => {
      const isCurrent = tier_1.tierId === activeTierId;
      return <li key={tier_1.id} ref={isCurrent ? currentItemRef : undefined} className={styles.item}><RewardsTierCard tier={tier_1} isCurrent={isCurrent} rowCount={maxBenefitRows} discount={discounts[tier_1.tierId]} /></li>;
    });
    $[10] = activeTierId;
    $[11] = discounts;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <ul id="rewards-tiers" ref={trackRef} className={styles.track} aria-label={t6}>{t7}</ul>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}
function _temp2(tier_0) {
  return tier_0.benefits.length;
}
function _temp(tier) {
  return [tier.tierId, tier.discount];
}